export default {
    "BLOCK_DEFAULT_WIDTH": -1,
    USER_NAME_HTML_ELEMENT_ID:["header_headerResponsive_responsiveNav_lblName","ctl00_header_headerResponsive_responsiveNav_lblName"]
}


// WEBPACK FOOTER //
// ./src/frontend/config/constants.js